export default [
    {
        name:"Intro",
        path:"Intro",
        component:()=>import("@/view/WebViews/About/Intro"),
        meta:{
            title:"简介",
        }
    },
    {
        name:"Team",
        path:"Team",
        component:()=>import("@/view/WebViews/About/Team"),
        meta:{
            title:"团队风采",
        }
    },
    {
        name:"Client",
        path:"Client",
        component:()=>import("@/view/WebViews/About/Client"),
        meta:{
            title:"合作客户",
        }
    },
    {
        name:"Case",
        path:"Case",
        redirect:{name:"CaseTrademark"},
        component:()=>import("@/view/WebViews/About/Case"),
        meta:{
            title:"案例展示",
        },
        children:[
            {
                name:"CaseTrademark",
                path:"CaseTrademark",
                component:()=>import("@/view/WebViews/About/CaseTrademark"),
                
            },
            {
                name:"CasePatent",
                path:"CasePatent",
                component:()=>import("@/view/WebViews/About/CasePatent"),
            },
            {
                name:"CaseCopyright",
                path:"CaseCopyright",
                component:()=>import("@/view/WebViews/About/CaseCopyright"),
            },
            {
                name:"CaseMaintain",
                path:"CaseMaintain",
                component:()=>import("@/view/WebViews/About/CaseMaintain"),
            },
        ]
    },
    {
        name:"Recruitment",
        path:"Recruitment",
        component:()=>import("@/view/WebViews/About/Recruitment"),
        meta:{
            title:"人才招聘",
        }
    },
    {
        name:"History",
        path:"History",
        component:()=>import("@/view/WebViews/About/History"),
        meta:{
            title:"发展历程",
        }
    },
    {
        name:"Qualification",
        path:"Qualification",
        component:()=>import("@/view/WebViews/About/Qualification"),
        meta:{
            title:"荣誉资质",
        }
    },
]